import { emptySplitApi } from './emptySplitApi';

import { TGetFarmerScanData } from '../utils/types';

export const farmerScanService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      getFarmerScansList: builder.query<
        TGetFarmerScanData,
        string
      >({
        query: (searchString) => ({
          method: 'GET',
          url: `product/scan/reward-points/${searchString}`,
        }),
      }),
    }),
  });

export const {
  useGetFarmerScansListQuery,
  useLazyGetFarmerScansListQuery,
} = farmerScanService;
